export const API_URL_1              = process.env.REACT_APP_API_URL1;
export const API_URL_2              = process.env.REACT_APP_API_URL2;
export const API_URL_3              = process.env.REACT_APP_API_URL3;
export const SQUARE_APPLICATION_ID  = process.env.REACT_APP_SQUARE_PAY_APP_ID;
export const SQUARE_LOCATION_ID     = process.env.REACT_APP_SQUARE_PAY_LOC_ID;